export const ARABIC_DOMAINS = [
    "ar.online-arabic-casino.net",
    "ar.888-casinoarabic.com",
    "ar.arabiccasino888.com",
    "ar.casinoarabic-888.com",
    "ar.888casino-uae.com",
    "ar.888casino-games.com",
    "ar.888casino-arabic.com",
    "ar.888slots-uae.com",
    "ar.888casinoarabic.net",
    "ar.888slot-games.com",
    "ar.888-uae.com",
    "ar.888games-uae.com",
    "ar.triple-eight-games.com",
    "ar.tripleeight.live",
    "ar.casinoarabic888.com",
    "ar.live-table-games.net",
    "ar.online-games888.com",
    "ar.playat888-games.com",
    "ar.888casinofun.com",
    "ar.fungames-888.com",
    "ar.888casinoparty.com",
    "ar.play-triple8.com",
    "ar.arabic-live.games",
    "ar.888-slots.net",
    "ar.a7la-games.com",
    "ar.a7la-games.net",
    "ar.triple-eight-games.live",
    "ar.triple-eight-games.net",
    "ar.arabic-live-games.com",
    "ar.arabic-triple-eight.com",
    "ar.play-casino-now.com",
    "ar.playat888online.com",
    "ar.777arab.com",
    "ar.777arabgames.com",
    "ar.777arabic.com",
    "ar.777arabic-game.com",
    "ar.777arab-online.com",
    "ar.777fungame.com",
    "ar.777gamesonline.com",
    "ar.777online-games.com",
    "ar.777online-gaming.com",
    "ar.777partygames.com",
    "ar.online7777ar.com",
    "ar.online777arab.com",
    "ar.online777arzone.com",
    "ar.online77ar.com",
    "ar.web777ar.com",
    "ar.play777home.com",
    "ar.play777star.com",
    "ar.play777world.com",
    "ar.play777now.com",
    "ar.play777web.com",
    "ar.ar-888-casino.com",
    "ar.888casino-ar.com",
    "ar.ar888-casino.com",
    "ar.arab888-casino.com",
    "ar.casinoelarab-888.com",
    "ar.alarab-888casino.com",
    "ar.casinoalarab-888.com",
    "ar.888casino-alarab.com",
    "ar.888casino-arabian.com",
    "ar.arabian-888casino.com",
    "ar.888-casino-arabian.com",
    "ar.888-casino-alarab.com"
]